
import {
    SEARCH_ACTION_TYPE,
    CLEAR,
    SELECT_OBJECT_TYPE,
    SET_SEARCH_PARAM
} from '../sagas/search';

import {
    ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE,
} from '../sagas/isknExplorer';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

import { DEFINITION_PAR } from '../common/common/iskn/par';

const initialState = {
    ...loaderInitialState
};

function clear(state, action) {
    return {
        ...loaderInitialState,
        paramsValues: state.paramsValues,
        selectedObjectType: state.selectedObjectType
    };
}

export function getIsSearchLoading(state) {
    return state.loading;
}

export function getSearchData(state, objectType) {
    return getSearchForObjectType(state, objectType).data || null;
}

export function getSearchParams(state, objectType) {
    return objectType
        ? getSearchForObjectType(state, objectType).params || {}
        : getSearchParamsForAll(state);
}

function getSearchParamsForAll(state) {
    let searchParams = {}
    let objectTypes = [ DEFINITION_PAR ];
    objectTypes.forEach(item => {
        let params = getSearchForObjectType(state, item.objectType).params || {};
        for (let name in params) {
            if (params[name] !== '') {
                searchParams[`${item.objectType}:${name}`] = params[name];
            }
        }
    });
    return searchParams;
}

export function getParamsValues(state) {
    return state.paramsValues;
}

function setParamsValues(state, action) {
    return {
        ...state,
        paramsValues: action.data?.result?.result?.paramsValues
    };
}

function clearSearchData(state, action) {
    if (action.objectType) {
        let params = state.forObjectType && state.forObjectType[action.objectType]
            ? state.forObjectType[action.objectType].params
            : null;

        return {
            ...state,
            forObjectType: {
                ...state.forObjectType,
                [action.objectType]: {
                    params: params
                }
            }
        };
    } else {
        return {
            ...state
        };
    }
}

function setSearchData(state, action) {
    let objectType = action.data?.result?.result?.objectType;
    if (objectType) {
        let searchForObjectType = {
            ...(getSearchForObjectType(state, objectType) || {}),
        };
        searchForObjectType.data = action.data.result.result.data;

        return {
            ...state,
            forObjectType: {
                ...state.forObjectType,
                [objectType]: searchForObjectType
            }
        };
    } else {
        return {
            ...state
        };
    }
}

function setSearchParam(state, action) {
    let searchForObjectType = {
        ...(getSearchForObjectType(state, action.objectType) || {}),
    };
    searchForObjectType.params = {
        ...(searchForObjectType.params || {})
    };
    searchForObjectType.params[action.name] = action.value;

    return {
        ...state,
        forObjectType: {
            ...state.forObjectType,
            [action.objectType]: searchForObjectType
        }
    };
}

function getSearchForObjectType(state, objectType) {
    let searchForObjectType = {};
    if (state.forObjectType && state.forObjectType[objectType]) {
        searchForObjectType = state.forObjectType[objectType];
    }
    return searchForObjectType;
}

export function getSelectedObjectType(state) {
    return state.selectedObjectType || DEFINITION_PAR.objectType;
}

function selectObjectType(state, action) {
    return {
        ...state,
        selectedObjectType: action.objectType
    };
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(SEARCH_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {

            case ISKN_EXPLORER_SET_ISKN_DATE_ACTION_TYPE:
                return {
                    ...initialState
                };

            case CLEAR:
                return clear(state, action);

            case SELECT_OBJECT_TYPE:
                return selectObjectType(state, action);

            case SET_SEARCH_PARAM:
                return setSearchParam(state, action);

            case SEARCH_ACTION_TYPE.DEFAULT:
                switch (action.operation) {
                    case 'search/SEARCH_OBJECT':
                        state = clearSearchData(state, action);
                        break;
                    default:
                        break;
                 }
                 return loaderReducer(state, action);

            case SEARCH_ACTION_TYPE.SUCCESS:
                switch (action.data?.result?.operation) {
                    case 'search/GET_PARAMS_VALUES':
                        state = setParamsValues(state, action);
                        break;
                    case 'search/SEARCH_OBJECT':
                        state = setSearchData(state, action);
                        break;
                    default:
                        console.warn(`unknown result operation "${action.data?.result?.operation}"`);
                        break;
                }
                return loaderReducer(state, action);

            default:
                return loaderReducer(state, action);
        }
    };
}
